import { FaStarOfLife } from 'react-icons/fa';
import { Container, ContainerInterno, ContainerInternoCheck } from '../styles';
import RModal from '../../../components/Rsuite/Modal';
import { CustomInput } from '../../../components/CustomInput';
import { Label } from '../../../components/Label';
import { CustomSelectPicker } from '../../../components/CustomSelectPicker';
import { CustomToggle } from '../../../components/CustomToggle';
import { boolOptions } from '../../../constants/boolOptions';
import { useCreateEditMount } from './useCreateEditMount';
import { DeleteModalMounting } from '../ModalDeletarMonatagem';
import { Footer } from './Footer/Footer';

export const CreateEditMount = ({ modal, close, montagem, setMontagens }) => {
  const {
    form,
    openDeleteMounting,
    cadastrarMontagem,
    editarMontagem,
    handleCheckAll,
    onChange,
    handleOpenDelete,
    onCloseDeleteMounting,
  } = useCreateEditMount({ setMontagens, montagem, modal, close });

  return (
    <>
      <RModal
        open={modal}
        onClose={close}
        title={montagem ? `Editar Montagem` : 'Cadastrar Montagem'}
        sizeBody
        footer={
          <Footer
            montagem={montagem}
            close={close}
            editarMontagem={editarMontagem}
            cadastrarMontagem={cadastrarMontagem}
            handleOpenDelete={handleOpenDelete}
          />
        }
      >
        <Container>
          <ContainerInterno>
            <Label htmlFor="descricao">
              <b>Código PDV</b>
            </Label>
            <CustomInput
              type="text"
              placeholder="CodigoPDV"
              value={form.codigoPDV}
              min="0"
              onChange={onChange('codigoPDV')}
            />
          </ContainerInterno>
          <ContainerInterno>
            <Label htmlFor="descricao">
              <b>
                Descrição <FaStarOfLife size={8} color="#FF0000" />
              </b>
            </Label>
            <CustomInput
              type="text"
              value={form.descricao}
              min="0"
              onChange={onChange('descricao')}
            />
          </ContainerInterno>
        </Container>
        <Container>
          <ContainerInterno>
            <Label htmlFor="qtdSemCusto">
              <b>Qtd. S/Custo</b>
            </Label>
            <CustomInput
              style={{ width: 200 }}
              type="number"
              value={form.qtdSemCusto}
              onChange={onChange('qtdSemCusto')}
            />
          </ContainerInterno>
          <ContainerInterno>
            <Label htmlFor="qtdSemCusto">
              <b>Incremento</b>
            </Label>
            <CustomInput
              type="number"
              value={form.incrementar}
              min={1}
              disabled={form.addMaisVezes !== 'False' ? false : true}
              onChange={onChange('incrementar')}
            />
          </ContainerInterno>
        </Container>
        <Container>
          <ContainerInterno>
            <Label htmlFor="qtdMax">
              <b>Qtd. Min.</b>
            </Label>
            <CustomInput
              type="number"
              value={form.qtdMin}
              min="0"
              disabled={true !== 'False' ? false : true}
              onChange={onChange('qtdMin')}
            />
          </ContainerInterno>
          <ContainerInterno>
            <Label htmlFor="qtdMax">
              <b>Qtd. Máx.</b>
            </Label>
            <CustomInput
              type="number"
              value={form.qtdMax}
              min="0"
              disabled={true !== 'False' ? false : true}
              onChange={onChange('qtdMax')}
            />
          </ContainerInterno>
        </Container>
        <Container>
          <ContainerInterno>
            <Label htmlFor="ativo">
              <b>Add. Item mais vezes</b>
            </Label>
            <CustomSelectPicker
              data={boolOptions}
              style={{ width: 200 }}
              onChange={onChange('addMaisVezes')}
              searchable={false}
              defaultValue={
                montagem !== null && montagem.AddItemMaisVezes === 'True'
                  ? boolOptions[0].value
                  : boolOptions[1].value
              }
            />
          </ContainerInterno>

          <ContainerInterno>
            <Label htmlFor="ativo">
              <b>Borda por Tamanho</b>
            </Label>
            <CustomSelectPicker
              data={boolOptions}
              style={{ width: 200 }}
              onChange={onChange('borda')}
              searchable={false}
              defaultValue={
                montagem !== null && montagem.BordaTamanho === 'True'
                  ? boolOptions[0].value
                  : boolOptions[1].value
              }
            />
          </ContainerInterno>
        </Container>
        <Container>
          <ContainerInternoCheck
            style={{
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Label for="controlaEmbalagem" style={{ marginRight: 10 }}>
              <b>Controla Embalagem</b>
            </Label>
            <CustomToggle
              checked={form.controlaEmbalagem}
              id="controlaEmbalagem"
              onChange={handleCheckAll}
            />
          </ContainerInternoCheck>
        </Container>
        <Container>
          <ContainerInternoCheck
            style={{
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Label for="cobrancaItemMaiorValor" >
              <b>Cobrança por Item de Maior Valor 
                <b style={{ fontSize: 10, margin: '0px 10px', color: '#f00' }}>
                  (Não realiza a soma dos itens apenas do maior)</b>
                </b>
            </Label>
            <CustomToggle
              checked={form.cobrancaItemMaiorValor}
              id="cobrancaItemMaiorValor"
              onChange={onChange('cobrancaItemMaiorValor')}
            />
          </ContainerInternoCheck>
        </Container>
      </RModal>
      <DeleteModalMounting
        open={openDeleteMounting}
        onClose={onCloseDeleteMounting}
        montagem={montagem}
        setMontagens={setMontagens}
      />
    </>
  );
};
